import * as m from 'motion/react-m';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import styled, { createGlobalStyle, css } from 'styled-components';

import { values } from 'chime-ui/system';
import { screenSizes } from 'chime-ui/system/media';

import zIndex from 'consts/zIndex';

import { Button } from 'styles/Button';

const modalContentZIndex = zIndex.contentModal + 1;

const Overlay = styled(m.div)`
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${props =>
    props.theme.styles.bottomSheet.overlay.backgroundColor};
  opacity: ${props => props.theme.styles.bottomSheet.overlay.opacity};
  width: 100%;
  z-index: ${zIndex.contentModal};
`;

export const ResponsiveBottomSheetButton = styled(Button)`
  margin: 1.5rem 0 0 0;
`;

const ModalWrapper = styled.div`
  align-items: end;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: ${modalContentZIndex};

  ${props =>
    props.isTablet &&
    css`
      align-items: center;
    `}
`;

const ModalContent = styled(m.div)`
  background-color: #fff;
  border-radius: 1rem 1rem 0 0;
  box-shadow: 0px -2px 8px 0px rgba(51, 51, 51, 0.16);
  max-width: 27rem;
  padding: 1rem 1.5rem 1.5rem;

  ${props =>
    props.isTablet &&
    css`
      border-radius: 1.5rem;
      box-shadow: 0 -8px 12px 0 rgba(0, 0, 0, 0.08);
      padding: 1.5rem 2.875rem;
    `}
`;

// Prevents scrolling of the background when this is open
const BodyStyle = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;

export default function ResponsiveBottomSheet({ children, closeBottomSheet }) {
  const isTablet = useMedia(`(min-width: ${screenSizes.tablet}px)`);

  return (
    <>
      <BodyStyle />
      <Overlay
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.72 }}
        exit={{ opacity: 0 }}
        transition={{ ease: 'easeInOut', delay: values.TIMEOUT_DELAY / 2 }}
        onClick={closeBottomSheet}
      />
      <ModalWrapper isTablet={isTablet}>
        <ModalContent
          initial={{ y: '200%' }}
          animate={{ y: 0 }}
          exit={{ y: '200%' }}
          transition={{ ease: 'easeInOut', delay: values.TIMEOUT_DELAY }}
          isTablet={isTablet}
        >
          {children}
        </ModalContent>
      </ModalWrapper>
    </>
  );
}

ResponsiveBottomSheet.propTypes = {
  children: PropTypes.node.isRequired,
  closeBottomSheet: PropTypes.func.isRequired,
};
